import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateConversionPipe } from "./date-conversion.pipe";


@NgModule({
  declarations: [DateConversionPipe],
  imports: [
    CommonModule
  ],
  exports: [DateConversionPipe]
})
export class DateConversionPipeModule {}
